import * as React from 'react';
import { cn } from '../cn';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  compact?: boolean;
}
export function EmptyState({ icon, title, description, action, className, compact }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center', compact ? 'py-8 px-4' : 'py-16 px-6', className)}>
      {icon ? <div className="mb-4 flex size-12 items-center justify-center rounded-[var(--radius-lg)] bg-fill-2 text-text-2 [&>svg]:size-6">{icon}</div> : null}
      <h3 className="text-[15px] font-semibold text-text">{title}</h3>
      {description ? <p className="mt-1 max-w-[42ch] text-[13px] text-text-2">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
